import TransactionListWidgetView from './TransactionListWidgetView.vue';
import TransactionListWidgetEditor from './TransactionListWidgetEditor.vue';

export const type = 'transactionList';
export const view = TransactionListWidgetView;
export const editor = TransactionListWidgetEditor;

export function builder() {
  return {
    type,
    pageNumber: 1,
    numPages: 1,
    numTransactionsInPage: 1,
    top: 0,
  };
}
